<template>
  <div class="hero section-type-s bground-config-clean presentation">
    <div>
      <div class="personal-container">
        <div class="row section-type-s pt-5 justify-content-center ">
          <div class="col-12 col-md-8 col-lg-5 vertical-align ">
            <div class="fonfoBlanco">
              <div>
                <h1 class="mb-24">
                  Misión
                </h1>
                <p class=" mb-32">
                  Ser líderes en el ramo de ventas y servicio de autos y comerciales General Motors, ofreciendo productos y servicios de la más alta calidad con una excelente atención, que supere las expectativas de nuestros clientes. Asegurar el bienestar y seguridad de nuestro personal para lograr consolidar como un grupo fuerte y vanguardista.
                </p>
              </div>
              <div>
                <h1 class=" mb-24">
                  Visión
                </h1>
                <p class="mb-32">
                  Enfocar todos nuestros recursos y empeño en crear una nueva cultura dispuesta al cambio a servir y compartir, basada en la confianza el respeto mutuo y el trabajo en equipo. Siendo esta la fortaleza que engrandecerá a nuestra empresa para ganar el reconocimiento de clientes, proveedores, empleados, así como también accionistas y poder garantizar la permanencia y liderazgo en el mercado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nosotros'
}
</script>

<style scoped>
  .fonfoBlanco {
    background: url(https://www.toptal.com/designers/subtlepatterns/patterns/interlaced.png);
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

</style>
